import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { ToolReturnsInspectComponent } from "@app/roles/atom-operator/pages/tool-returns";
import { Log } from "ng2-logger";

@Component({
    selector: 'app-tool-reset-form',
    templateUrl: './tool-reset-form.component.html',
    styleUrls: ['./tool-reset-form.component.scss']
})
export class ToolResetFormComponent implements OnInit, OnChanges {
  _logger = Log.create(ToolResetFormComponent.name);

  @Input() scannedTools;
  @Input() isScanListenerActive = false;

  @Output() toolWasScanned = new EventEmitter();
  @Output() rowAlertClicked = new EventEmitter();
  @Output() resetFormStatus = new EventEmitter();

  resetForm: UntypedFormGroup;

  static scannedToolsValidator(control: UntypedFormControl): { [s: string]: boolean } {
    if (
      control.value.length < ToolReturnsInspectComponent.returnTools.length ||
      !control.value.length
    ) {
      return { allToolsInspected: true };
    }
    return null;
  }

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['scannedTools'] && !changes['scannedTools'].firstChange) {
      this._logger.info('scannedTools input changed, resetting form');
      this.initForm();
    }
  }

  private initForm() {
    this.resetForm = this.formBuilder.group({
      scannedTool: [
        [],
        ToolResetFormComponent.scannedToolsValidator.bind(this)
      ]
    });

    this.resetFormStatus.emit(this.resetForm.valid);
  }

    onToolScanned(event) {
        this._logger.info('onToolScanned:: Tool was successfully scanned', event);
        event.inspected = true;

        const parentSet = this.findParentSet(event.id);
        if (parentSet) {
            const allChildrenScanned = parentSet.tools.every(child => child.inspected);
            if (allChildrenScanned) {
            parentSet.inspected = true;
            }
        }

        this.toolWasScanned.emit(event);
        this.resetFormStatus.emit(this.resetForm.valid);
        }

    private findParentSet(toolId: number) {
        return this.scannedTools?.find(
            t => t.tools && t.tools.some(c => c.id === toolId)
        );
    }


  onRowAlertClick(event) {
    this.rowAlertClicked.emit(event);
  }
  
}
